import { createContext, useContext, useMemo, ReactNode } from 'react'

interface SidebarContextType {
  isSidebarCollapsed: boolean
  navWidth: number
  sidebarWidth: number
  isMobile: boolean
  activePanel: string | null
  isSheetExpanded: boolean
  onSearchSubmit: () => void
  onClosePanel: () => void
  onCollapseSheet: () => void
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

export function SidebarProvider({
  children,
  isSidebarCollapsed,
  navWidth,
  sidebarWidth,
  isMobile,
  activePanel,
  isSheetExpanded,
  onSearchSubmit,
  onClosePanel,
  onCollapseSheet,
}: {
  children: ReactNode
  isSidebarCollapsed: boolean
  navWidth: number
  sidebarWidth: number
  isMobile: boolean
  activePanel: string | null
  isSheetExpanded: boolean
  onSearchSubmit: () => void
  onClosePanel: () => void
  onCollapseSheet: () => void
}) {
  const value = useMemo(
    () => ({ isSidebarCollapsed, navWidth, sidebarWidth, isMobile, activePanel, isSheetExpanded, onSearchSubmit, onClosePanel, onCollapseSheet }),
    [isSidebarCollapsed, navWidth, sidebarWidth, isMobile, activePanel, isSheetExpanded, onSearchSubmit, onClosePanel, onCollapseSheet]
  )

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSidebar() {
  const context = useContext(SidebarContext)
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }
  return context
}
